import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@features/campaigns/shared/consts/queryKeys.ts';
import { listThematicPackages } from '@features/campaigns/shared/services/thematicPackage/listThematicPackages.ts';

interface UseThematicPackagesProps {
  isEnabled: boolean;
}

export function useThematicPackages({ isEnabled }: UseThematicPackagesProps) {
  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.THEMATIC_PACKAGES],
    queryFn: () => listThematicPackages(),
    enabled: isEnabled,
  });

  return {
    thematicPackages: data?.items ?? [],
    areThematicPackagesLoading: isLoading,
  };
}
